import { KEYS } from 'app/constants/SceneConstants';
import { ControlsGuide } from '../display/ui/ControlsGuide';
import { HeroPreviewer } from '../display/ui/HeroPreviewer';
import { ItemSelectButton } from '../input/ItemSelectButton';
import SceneBaseTT from './SceneBaseTT';

export default class Pause extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.Pause, active: false });
  }

  create() {
    super.create();
    this.setBackgroundImage('overlay_purple');

    this._heroid = this.game.player.activeHero || 'robin';

    this._heroPreview = new HeroPreviewer(this, this._heroid);
    this._heroPreview.x = 840;
    this._heroPreview.y = 512;

    this.add.image(840, 512, 'graphics', 'item_select_frame_over').setOrigin(0.5, 1);
    this.add.spine(842, 151, 'fire', 'animation', true);
    this.add.image(840, 150, 'locale_text', 'character_name_' + this._heroid);

    this._controls = new ControlsGuide(this, !this.game.isDesktop);
    this._controls.x = this.game.viewportController.leftPadded;
    this._controls.y = 530;

    this._characterDemoTimer = 0;
    this._characterDemoIndex = 0;
    this._characterDemoQueue = ['walk', 'idle', 'jump', 'attack', 'special', 'pickup'];
  }

  update(time, delta) {
    this._characterDemoTimer -= delta;
    if (this._characterDemoTimer <= 0 && this._heroPreview) {
      this.triggerNextDemo();
      this._characterDemoTimer = 2000;
    }

    if (this._controls && this._controls.state !== this._heroPreview.state) {
      this._controls.setState(this._heroPreview.state);
    }
  }

  triggerNextDemo() {
    const action =
      this._characterDemoQueue[this._characterDemoIndex % this._characterDemoQueue.length];
    this._characterDemoIndex++;
    this._heroPreview.tiggerDemo(action);
    this._controls.setState(this._heroPreview.state);
  }

  shutdown() {
    super.shutdown();
  }
}
